import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductShowcase } from './components/ProductShowcase';
import { VolumesDetail } from './components/VolumesDetail';
import { GestionSection } from './components/GestionSection';
import { BonusesSection } from './components/BonusesSection';
import { CountdownSection } from './components/CountdownSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { FooterSection } from './components/FooterSection';
import { PurchaseNotification } from './components/PurchaseNotification';
// Preload hero image immediately for fastest LCP
if (typeof document !== 'undefined' && !document.querySelector('link[rel="preload"][as="image"]')) {
  const preloadImg = document.createElement('link');
  preloadImg.rel = 'preload';
  preloadImg.as = 'image';
  preloadImg.href = 'https://cdn.magicpatterns.com/uploads/4RNMGryCsfyVfk5DBR6qtW/Sin_titulo_(420_x_420_px)_(2).png';
  preloadImg.type = 'image/png';
  document.head.insertBefore(preloadImg, document.head.firstChild);
}
export function App() {
  useEffect(() => {
    // Defer Meta Pixel to idle time
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => loadPixel(), {
        timeout: 10000
      });
    } else {
      setTimeout(loadPixel, 8000);
    }
  }, []);
  return <main className="font-body text-white bg-brand-dark overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <ProductShowcase data-id="element-3" />
      <VolumesDetail data-id="element-4" />
      <GestionSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <CountdownSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />
      <FooterSection data-id="element-13" />
      <PurchaseNotification data-id="element-14" />
    </main>;
}
function loadPixel() {
  if (typeof window !== 'undefined' && !(window as any).fbq) {
    const f = window as any;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    (window as any).fbq('init', '1170774765082882');
    (window as any).fbq('track', 'PageView');
  }
}